// When naming new mixpanel events please follow the best practices: https://lyrahealth.atlassian.net/wiki/spaces/DS/pages/2598110057/Mixpanel+event+naming+best+practices
export const mixpanelEvents = {
  BUTTON_PRESS: 'Button Press',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  OUTCOMES_AGREED: 'Outcomes Consent Agreed',
  OUTCOMES_AGREED_FAILED: 'Failed Outcomes Consent Agreed',
  REGISTER: 'Register',
  STS: 'Show Session Tracking info',
  SUBMIT_PAYMENT: 'Submit Payment',
  SUBMIT_PAYMENT_FAILED: 'Failed Submit Payment',
  FILTER_CHANGE: 'Filter Change',
  SUBMIT_ICD10S: 'Submit ICD-10s',
  SUBMIT_ICD10S_FAILED: 'Submit ICD-10s Failure',
  OUTCOME_REMINDER: 'Show Outcome Reminder',
  SHOW_PROVIDER_AVAILABILITY: 'Availability Feature Shown',
  SHOW_PROVIDER_CAPACITY: 'Capacity Availability Feature Shown',
  UPDATE_CAPACITY: 'Update Capacity',
  BLOCK_PAYMENT: 'Payment Blocked',
  SHOW_RECOMMENDATION_EXPLANATION_MODAL: 'Show utilization recommendation explanation modal',
  CHANGE_QUARTERLY_PROGRESS_TARGET: 'Change selected target value for quarterly progress chart',
  SEND_MESSAGE: 'Send a message to a client',
  OPEN_MESSENGER: 'Open the messenger',
  REVIEW_CONTENT: 'Review some content',
  OPEN_GO_SEARCH_BAR: 'Open Go Search Bar',
  OPEN_CALENDAR_TAB: 'Open calendar tab',
  CONFIRM_CANCEL_SESSION_PRIOR_TO_START: 'Confirm cancel session prior to start',
  CONFIRM_SCHEDULE_NEW_SESSION: 'Confirm Schedule New Session',
  CANCEL_SESSION: 'Cancel session',
  RESCHEDULE_SESSION: 'Reschedule session',
  CONFIRM_RESCHEDULE_SESSION: 'Confirm reschedule session',
  CLOSE_GO_SEARCH_BAR: 'Close Go Search Bar',
  NAVIGATE_TO_CLIENT_FROM_GO_SEARCH_BAR: 'Navigate to client from Go Search Bar',
  SHOW_OOO_TAB: 'Show OOO tab',
  SEND_SCHEDULED_OOO_SELECTED: 'Send scheduled OOO selected',
  GO_BACK_TO_EDIT_OOO_MESSAGE_SELECTED: 'Go back to edit OOO message selected',
  SEND_OOO_MESSAGE_SELECTED: 'Send OOO message selected',
  UPDATING_EXPEDITED_BOOKING: 'Expedited Booking updated',
  ENABLED_EXPEDITED_BOOKING: 'Enabled Expedited Booking',
  SELECTED_EXPEDITED_BOOKING_GRACE_PERIOD: 'Selected Expedited Booking grace period',
  TOGGLED_EXPEDITED_BOOKING: 'Toggled Expedited Booking',
  FILTER_PP_CONTENT_LIBRARY: 'filter provider portal content library',
  AVAILABILITY_ALERT_LEARN_MORE: 'Learn more selected in the availability alert',
  AVAILABILITY_ALERT_OPEN_CALENDAR: 'Open calendar selected from the availability alert',
  AVAILABILITY_ALERT_CLOSE_MODAL: 'Close the availability alert',
  CAPACITY_AVAILABILITY_ALERT_MODAL_SHOWN: 'Capacity setting availability modal surfaced',
  PERSISTENT_AVAILABILITY_ALERT_MODAL_SHOWN: 'Persistent availability alert pop over is surfaced',
  PERSISTENT_AVAILABILITY_ALERT_LEARN_MORE: 'Provider clicks on "Learn more" to link to ZenDesk',
  PERSISTENT_AVAILABILITY_ALERT_OPEN_CALENDAR: 'Provider clicks on "Open calendar" to open their google calendar',
  PERSISTENT_AVAILABILITY_ALERT_CLOSE_MODAL: 'Provider closes the availability modal',
  CALENDAR_SETUP_CANCEL_MODAL_SHOWN: 'Calendar setup cancel modal shown',
  CALENDAR_TEMPLATE_CANCEL_MODAL_SHOWN: 'Calendar template cancel modal shown',
  CALENDAR_TEMPLATE_WORKING_HOURS_UPDATED: 'Calendar template working hours updated',
  ALERT_SHOWN_UNDER_BOOKABLE: 'Alert shown under bookable',
  ALERT_SHOWN_OVER_BOOKABLE_TIME_OFF: 'Alert shown over bookable time off',
  ALERT_SHOWN_CAPACITY: 'Alert shown capacity',
  CLIENT_INTAKE_FORM_OPEN_CLIENT_HOME: 'client_intake_form_open_client_home',
  OPEN_MESSAGE_CENTER: 'open message center',
  MESSAGE_CENTER_COMPOSE: 'message center compose',
  MESSAGE_CENTER_EXPAND_CLIENT_DETAILS: 'message center expand client details',
  MESSAGE_CENTER_COLLAPSE_CLIENT_DETAILS: 'message center collapse client details',
  MESSAGE_CENTER_CLIENT_DETAILS_OPEN_CLIENT_PROFILE: 'message center client details open client profile',
  MESSAGE_CENTER_POPOUT_MESSAGING_WINDOW: 'message center popout messaging window',
  MESSAGE_CENTER_USE_UNREAD_FILTER: 'message center use unread filter',
  MESSAGE_CENTER_USE_ACTIVE_FILTER: 'message center use active filter',
  MESSAGE_CENTER_USE_UNSCHEDULED_FILTER: 'message center use unscheduled filter',
  MESSAGE_CENTER_USE_LYRA_AI_ENABLED_FILTER: 'message center use lyra ai enabled filter',
  CLIENT_LIST_SELECT_CLIENT_NAME: 'client list select client name',
  CLIENT_LIST_SEARCH_CLIENT_NAME: 'client list search client name',
  CLIENT_LIST_SORT_COLUMN_HEADER: 'client list sort column header',
  CLIENT_LIST_FILTER_STATUS: 'client list filter status',
  CLIENT_LIST_FILTER_PROGRAM: 'client list filter program',
  CLIENT_LIST_FILTER_EPISODE_PROGRESS: 'client list filter episode progress',
  CLIENT_LIST_FILTER_NEXT_SESSION: 'client list filter next session',
  CLIENT_LIST_FILTER_SESSION_TYPE: 'client list filter session type',
  CLIENT_LIST_FILTER_ACTIVITY_STATUS: 'client list filter activity status',
  CLIENT_LIST_FILTER_MODALITY_TYPE: 'client list filter modality type',
  OPEN_SMART_SUGGESTIONS_FROM_MESSAGE_CENTER: 'open smart suggestions from message center',
  OPEN_SMART_SUGGESTION_SIDE_PANEL: 'open smart suggestions side panel',
  INSERT_SMART_SUGGESTION_INTO_MESSAGE: 'insert smart suggestion into message',
  CLOSE_SMART_SUGGESTION_SIDE_PANEL: 'close smart suggestions side panel',
  OPEN_ORIGINAL_FORM_FROM_SMART_SUGGESTION: 'open original form from smart suggestion',
  OPEN_CONVERSATION_FROM_SMART_SUGGESTION: 'open conversation from smart suggestion',
  DELETE_SMART_SUGGESTION_ICON: 'delete smart suggestion icon',
  DELETE_SMART_SUGGESTION_CONFIRM: 'delete smart suggestion confirm',
  EDIT_SMART_SUGGESTION_ICON: 'edit smart suggestion icon',
  OPEN_MESSAGE_DRAFTS_FROM_MESSAGE_CENTER: 'Open message drafts from message center',
  DELETE_DRAFTED_MESSAGE_ICON: 'delete drafted message icon',
  DELETE_DRAFTED_MESSAGE_CONFIRM: 'delete drafted message confirm',
  EDIT_DRAFTED_MESSAGE_ICON: 'edit drafted message icon',
  SEND_DRAFTED_MESSAGE_ICON: 'send drafted message icon',
  SEND_DRAFTED_MESSAGE_CONFIRM: 'send drafted message confirm',
  EDIT_DRAFTED_MESSAGE_FROM_DRAFT_PREVIEW: 'edit drafted message from draft preview',
  OPEN_MESSAGE_TEMPLATES_FROM_MESSAGE_CENTER: 'Open message templates from message center',
  ADD_MESSAGE_TEMPLATE_ENTRY_POINT: 'Add message template entry point',
  ADD_MESSAGE_TEMPLATE_CONFIRM: 'Add message template confirm',
  TOGGLE_SMART_SEND_TEMPLATE_ON_OFF: 'Toggle smart send template on off',
  DELETE_MESSAGE_TEMPLATE_ICON: 'Delete message template icon',
  DELETE_MESSAGE_TEMPLATE_CONFIRM: 'Delete message template confirm',
  EDIT_MESSAGE_TEMPLATE_ICON: 'Edit message template icon',
  EDIT_MESSAGE_TEMPLATE_CONFIRM: 'Edit message template confirm',
  SEND_MESSAGE_TEMPLATE_ICON: 'Send message template icon',
  OPEN_TEMPLATES_SIDE_PANEL: 'Open templates side panel',
  INSERT_MESSAGE_TEMPLATE_INTO_MESSAGE_FROM_SIDEBAR: 'Insert message template into message from sidebar',
  CLOSE_MESSAGE_TEMPLATES_SIDE_PANEL: 'Close message templates side panel',
  INSERT_WELLNESS_LIBRARY_ARTICLE_INTO_MESSAGE: 'Insert wellness library article into message',
  VIEW_ESSENTIALS_CONTENT: 'Provider View Essentials Content',
  PREVIEW_ESSENTIALS_CONTENT: 'Provider Preview Essentials Content',
  OPEN_IPC_THROUGH_NEW_CONNECTION_BANNER: 'Open IPC through new connection banner',
  OPEN_IPC_THROUGH_TRANSITION_BANNER: 'Open IPC through transition banner',
  OPEN_INTAKE_FORM_CARE_PROGRESS_SUMMARY: 'Open intake form from care progress summary',
  OPEN_CONSENT_FORM_CARE_PROGRESS_SUMMARY: 'Open consent form from care progress summary',
  OPEN_SESSION_NOTES_CARE_PROGRESS_SUMMARY: 'Open session notes from care progress summary',
  SCHEDULE_NEW_SESSION: 'Schedule New Session',
  CLOSE_SESSION: 'Close session',
  CONFIRM_CLOSE_SESSION: 'Confirm close session',
  OPEN_CLIENT_LIST: 'Open client list',
  ADD_NEW_CLIENT_OPEN_MODAL: 'Add new client open modal',
  ADD_NEW_CLIENT_SUBMIT: 'Add new client submit',
  ADD_NEW_CLIENT_CLOSE_SUCCESS_MODAL: 'Add new client close success modal',
  ADD_NEW_CLIENT_RESEND: 'Add new client resend registration',
  ADD_NEW_CLIENT_OPEN_DELETE_MODAL: 'Add new client open delete modal',
  ADD_NEW_CLIENT_CONFIRM_DELETE: 'Add new client confirm delete',
  ADD_NEW_CLIENT_SCHEDULE: 'Add new client schedule',
  LEGACY_CLIENT_ADD_TO_ENGAGE_CLICK: 'Legacy client add to engage click',
  SUBMIT_NOTE: 'Submit note',
  CLICK_REFER_TO_OTHER_CARE: 'Click Refer to Other Care',
  CLICK_CARE_REFERRAL_FORM_POP_UP: 'Click Care referral form pop-up',
  IPC_CONFIRM_SCHEDULE_NEW_SESSION: 'IPC Confirm Schedule New Session',
  OPEN_LEGACY_REQUEST_PAYMENT_FORM: 'Open legacy request payment form',
  OPEN_PAYMENT_HISTORY: 'Open payment history',
  OPEN_ELIGIBILITY_CHECKER: 'Open eligibility checker',
  OPEN_GET_SUPPORT: 'Open Get Support',
  OPEN_MY_INFO: 'Open My Info',
  OPEN_DOWNLOADS: 'Open Downloads',
  OPEN_SETTINGS: 'Open Settings',
  OPEN_CLIENT_LIST_LEGACY_PROVIDER_PORTAL_TAB: 'Open client list - Legacy Provider Portal',
  OPEN_CLIENT_LIST_ENGAGE_PLATFORM_TAB: 'Open client list - Engage Platform',
  DISCHARGE_CLIENT: 'Discharge client',
  CONFIRM_DISCHARGE_CLIENT: 'Confirm discharge client',
  END_EPISODE: 'End episode',
  CONFIRM_END_EPISODE: 'Confirm end episode',
  TOGGLE_GIVE_ACCESS_TO_LYRA_AI: 'Toggle give access to Lyra AI',
  OPEN_AI_CHAT_SUMMARIES_SIDE_PANEL: 'Open AI chat summaries side panel',
  OPEN_AI_CHAT_SUMMARY: 'Open AI chat summary',
  OPEN_CARE_INSIGHTS_PAGE: 'Open Care Insights Page',
  OPEN_ITEMS_FILTER_CHANGE: 'Open Items Filter Change',
  OPEN_ITEMS_MANUAL_TASK_CREATED: 'Open Items Manual Task Created',
  CAPACITY_UPDATED: 'Capacity Updated',
  TSL_APPROVED: 'Treatment Summary Letter Approved',
}

export const mixpanelPages = {
  CLIENTS: 'clients/lt',
  CLIENTS_ASSIGN: 'clients/lt/home/assign',
  CLIENTS_ASSIGNMENT: 'clients/lt/home/assignment',
  CLIENTS_CLOSE_SESSION: 'clients/lt/home/close-session',
  CLIENTS_HOME: 'clients/lt/home',
  CLIENTS_ACTIVITY: 'clients/lt/home/activities',
  CLIENTS_LIBRARY: 'clients/lt/home/library',
  CLIENTS_TRACK: 'clients/lt/home/track',
  CLIENTS_TRACKS: 'clients/lt/home/tracks',
  CLIENTS_PROFILE: 'clients/lt/home/profile',
  DASHBOARD: 'dashboard',
  LOGIN: 'login',
  CARE_INSIGHTS: 'performance/care-insights',
  MEASUREMENT_BASED_CARE: 'performance/measurement-based-care',
  PERFORMANCE: 'performance',
  PLATFORM_ENGAGEMENT: 'performance/platform-engagement',
  PLATFORM_ENGAGEMENT_QUARTERLY_DETAILS: 'performance/platform-engagement/quarterly-details',
  ELIGIBILITY_CHECKER: 'eligibility-checker',
  CLIENT_SESSIONS: 'clients/lt/home/sessions',
  CLIENT_NOTES: 'clients/lt/home/notes',
  CLIENT_NOTES_NEW: 'clients/lt/home/notes/new',
  CLIENT_DOCUMENTS: 'clients/lt/home/documents',
  DOCUMENTS: 'documents',
  MESSENGER: 'messages',
  MESSENGER_POPOUT: 'messages/popout',
}

/**
 * The session tracking information types.
 *
 * We track the following cases:
 *  - The initial session of a client
 *  - When the client has less than 5 sessions remaining
 *  - The last session
 *  - The number of sessions exceeds the number of available sessions.
 *
 * @type {Object} The list of different session traking info type.
 */
export const STSTypes = {
  STS_INITIAL: 'Initial',
  STS_WARNING: 'Warning',
  STS_LAST: 'Last',
  STS_EXCEEDED: 'Exceeded',
}

/**
 * Actions are the actions corresponding to a button click.
 */
export const actions = {
  OUTCOMES_CONSENT_NOT_NOW: 'Outcomes Consent Not Now',
  OUTCOMES_CONSENT_LEARN_MORE: 'Outcomes Learn More From Consent View',
  OUTCOMES_LEARN_MORE: 'Outcomes Learn More',
  OUTCOMES_CHANGE_DATE: 'Outcomes Change Date',
  OUTCOMES_LIFE_IMPAIRMENT: 'Outcomes Life Impairment',
  OUTCOMES_SELF_HARM: 'Outcomes Self Harm',
  OUTCOMES_ALLIANCE: 'Outcomes Alliance',
  OUTCOMES_GAD: 'View GAD7 Answers',
  OUTCOMES_PHQ: 'View PHQ9 Answers',
  OUTCOMES_GAD_TOOLTIP: 'View GAD7 Answers from graph tooltip',
  OUTCOMES_PHQ_TOOLTIP: 'View PHQ9 Answers from graph tooltip',
  RESET_PASSWORD: 'Reset Password',
  CHANGE_SESSION_PERIOD: 'View Different Session Period',
  ADD_ACTIVITY: 'Add Activity',
  VIEW_ASSESSMENT: 'View Assessment',
  VIEW_ACTIVITY_OVERVIEW: 'View Activity Overview',
  VIEW_MBC_PERCENTAGE_HELP_ARTICLE: 'View MBC Percentage Help Article',
  VIEW_MBC_PERCENTAGE_DETAILS: 'View MBC Percentage Details',
  VIEW_MBC_COUNT_DETAILS: 'View MBC Count Details',
  VIEW_MBC_COUNT_HELP_ARTICLE: 'View MBC Count Help Article',
  EDIT_ACTIVITY: 'Edit Activity',
  COPY_ACTIVITY: 'Copy Activity',
  MOVE_ACTIVITY: 'Move Activity',
  REMOVE_ACTIVITY: 'Remove Activity',
  PREVIEW_ACTIVITY: 'Preview Activity',
  CANCEL_SESSION: 'Cancel Session prior to start',
  CLOSE_SESSION: 'Close session',
  ATTEMPT_TO_CLOSE_SESSION_OUT_OF_ORDER: 'Attempt to close session out of order',
  RESCHEDULE_SESSION: 'Reschedule Session',
  UPDATE_AVAILABILITY: 'Availability Update',
  UPDATE_CAPACITY: 'Capacity Availability Update',
  AVAILABLE: 'Availability Changed to Available',
  NOT_AVAILABLE: 'Availability Changed to Not Available',
  activities: {
    edit: 'EDIT_ACTIVITY',
    copy: 'COPY_ACTIVITY',
    move: 'MOVE_ACTIVITY',
    unassign: 'REMOVE_ACTIVITY',
  },
  SUBMIT_ELIGIBILITY_CHECKER_SEARCH: 'Submit Eligibility Checker Search',
  LEARN_MORE: 'Learn More',
  VIEW_QUARTERLY_DETAILS: 'View Quarterly Details',
  BACK: 'Back',
  CURRENT_YEAR: 'Current Year',
  PREVIOUS_YEAR: 'Previous Year',
  MARK_MESSAGE_UNREAD: 'Mark Message Unread',
  WATCH_RECORDING: 'Watch recording with client',
  CALENDAR_DROPDOWN: 'Calendar in Dropdown Menu',
  HELP_CENTER_DROPDOWN: 'Help Center in Dropdown Menu',
  CALENDAR_NAV_BAR: 'Calendar in Nav Bar',
  CALENDAR_BANNER: 'Calendar in Banner',
  CONNECT_CALENDAR_START: 'Start Connect Calendar Flow',
  SCHEDULING_DA_CONNECTION_INSTRUCTIONS: 'Scheduling DA Connection Instructions',
  SCHEDULING_FOOTER_CONNECT_CALENDAR: 'Scheduling Footer Connect Calendar',
  SCHEDULING_FOOTER_SIMPLE_PRACTICE: 'Scheduling Footer Simple Practice',
  SCHEDULING_FOOTER_APPOINTMENT_BOOKING: 'Scheduling Footer Appointment Booking',
  SCHEDULING_FOOTER_PRIVATE_CALENDAR: 'Scheduling Footer Private Calendar',
  SCHEDULING_FOOTER_SUBMIT_TICKET: 'Scheduling Footer Submit Ticket',
  SCHEDULING_FOOTER_UPDATE_CALENDAR: 'Scheduling Footer Update Calendar',
  SCHEDULING_FOOTER_CLIENT_INTAKE: 'Scheduling Footer Client Intake',
  SCHEDULING_FOOTER_BEST_PRACTICES: 'Scheduling Footer Best Practices',
  SCHEDULING_FOOTER_ACCEPTING_REFERRAL: 'Scheduling Footer Accepting Referral',
  SCHEDULING_WALKTHROUGH_BACK: 'Scheduling Walkthrough Back',
  SCHEDULING_WALKTHROUGH_EXIT: 'Scheduling Walkthrough Exit',
  SCHEDULING_WALKTHROUGH_HOW_TO_CONNECT: 'Scheduling Walkthrough How to Connect',
  SCHEDULING_WALKTHROUGH_GOOGLE_CONNECTION: 'Scheduling Walkthrough Google Connection',
  SCHEDULING_STATUS_CONTACT_US: 'Scheduling Status Contact Us',
  SCHEDULING_BEGIN_CALENDAR_SUBMISSION: 'Scheduling Begin Calendar Submission',
  SCHEDULING_CLOSE_SUBMISSION_MODAL: 'Scheduling Close Submission Modal',
  SCHEDULING_SUBMISSION_LEARN_MORE: 'Scheduling Submission Learn More',
  SCHEDULING_COMPLETE_CALENDAR_SUBMISSION: 'Scheduling Complete Calendar Submission',
  SCHEDULING_ADD_BLOCKING_CALENDAR: 'Scheduling Add Blocking Calendar',
  SCHEDULING_REMOVE_BLOCKING_CALENDAR: 'Scheduling Remove Blocking Calendar',
  SCHEDULING_SET_APPOINTMENT_CALENDAR: 'Scheduling Set Appointment Calendar',
  SCHEDULING_AVAILABILITY_CALENDAR_LINK: 'Scheduling Availability Calendar Link',
  SCHEDULING_CALENDAR_VIEW_NEXT: 'Scheduling Calendar View Next Page',
  SCHEDULING_CALENDAR_VIEW_PREV: 'Scheduling Calendar View Previous Page',
  SCHEDULING_INTERNATIONAL_APPROVAL_EMAIL: 'Scheduling International Approval Email',
  SCHEDULING_INTERNATIONAL_FOOTER_HOW_TO_CONNECT: 'Scheduling International Footer How To Connect',
  SCHEDULING_INTERNATIONAL_FOOTER_MANAGE_AVAILABILITY: 'Scheduling International Footer Manage Availability',
  SCHEDULING_INTERNATIONAL_FOOTER_CALENDAR_FAQ: 'Scheduling International Footer Calendar FAQ',
  SCHEDULING_INTERNATIONAL_FOOTER_PORTAL_HELP: 'Scheduling International Footer Portal Help',
  SCHEDULING_INTERNATIONAL_FOOTER_RISK_MANAGEMENT: 'Scheduling International Footer Risk Management',
  SCHEDULING_INTERNATIONAL_FOOTER_SUBMIT_TICKET: 'Scheduling International Footer Submit Ticket',
  SCHEDULING_INTERNATIONAL_WALKTHROUGH_HOW_TO_CONNECT: 'Scheduling International Walkthrough How to Connect',
  SCHEDULING_INTERNATIONAL_AVAILABILITY_CALENDAR_LINK: 'Scheduling International Availability Calendar Link',
  SCHEDULING_INTERNATIONAL_STATUS_CONTACT_US: 'Scheduling International Status Contact Us',
  AI_DRAFTS_WORKSPACE_OPEN: 'AI_drafts_workspace_open',
  AI_DRAFTS_WORKSPACE_CLOSE: 'AI_drafts_workspace_close',
  UNFINISHED_NOTES_DASHLET_OPEN_NOTE: 'unfinished_notes_dashlet_open_note',
  CLIENT_NOTES_TAB_OPEN_NOTE: 'client_notes_tab_open_note',
  LOAD_PREVIOUS_FLEXIBLE_NOTE: 'load_previous_flexible_note',
  AI_DRAFTS_PASTE_INTO_NOTE: 'AI_drafts_paste_into_note',
  AI_DRAFTS_SUBMIT_FEEDBACK: 'AI_drafts_submit_feedback',
  CLIENT_INTAKE_FORM_AI_SUMMARY_SUBMIT_FEEDBACK: 'client_intake_form_AI_summary_submit_feedback',
  REFLECTION_INSIGHTS_SUBMIT_FEEDBACK: 'reflection_insights_submit_feedback',
  CARE_INSIGHTS_LEARN_MORE: 'care_insights_learn_more',
  CARE_INSIGHTS_SELECT_MONTH: 'care_insights_select_month',
  CALENDAR_SETUP_LEARN_MORE: 'Calendar Setup Learn More',
  CALENDAR_SETUP_SET_UP_CALENDAR: 'Calendar Setup Set Up Calendar',
  CALENDAR_SETUP_SAVE_SUCCESS: 'Calendar Setup Save Success',
  CALENDAR_SETUP_SAVE_BELOW: 'Calendar Setup Save Below',
  CALENDAR_SETUP_SAVE_ABOVE: 'Calendar Setup Save Above',
  CALENDAR_SETUP_CANCEL_MODAL_CONTINUE_EDITING: 'Calendar Setup Cancel Modal Continue Editing',
  CALENDAR_SETUP_CANCEL_MODAL_DISCARD_CHANGES: 'Calendar Setup Cancel Modal Discard Changes',
  CALENDAR_TEMPLATE_EDIT: 'Calendar Template Edit',
  CALENDAR_TEMPLATE_SAVE_SUCCESS: 'Calendar Template Save Success',
  CALENDAR_TEMPLATE_SAVE_BELOW: 'Calendar Template Save Below',
  CALENDAR_TEMPLATE_SAVE_ABOVE: 'Calendar Template Save Above',
  CALENDAR_TEMPLATE_CANCEL_MODAL_CONTINUE_EDITING: 'Calendar Template Cancel Modal Continue Editing',
  CALENDAR_TEMPLATE_CANCEL_MODAL_DISCARD_CHANGES: 'Calendar Template Cancel Modal Discard Changes',
  CALENDAR_TEMPLATE_SAVE_WORKING_HOURS: 'Save working hours',
  CALENDAR_MANAGEMENT_ADD_AVAILABLE: 'Calendar Management Add Available',
  CALENDAR_MANAGEMENT_DELETE_AVAILABLE: 'Calendar Management Delete Available',
  CALENDAR_MANAGEMENT_EDIT_AVAILABLE: 'Calendar Management Edit Available',
  CALENDAR_MANAGEMENT_JOIN_MEETING: 'Calendar Management Join Meeting',
  CALENDAR_MANAGEMENT_CLIENT_DETAILS: 'Calendar Management Client Details',
  CALENDAR_MANAGEMENT_OPEN_IN_GOOGLE_CALENDAR: 'Calendar Management Open in Google Calendar',
  NAVIGATION_MENU_SETTINGS: 'Navigation Menu Settings',
  NAVIGATION_CALENDAR_GEAR: 'Navigation Calendar Gear',
  NAVIGATION_CALENDAR_ZENDESK: 'Navigation Calendar Zendesk',
  CAPACITY_ALERT_OPEN_CAPACITY: 'Capacity Alert Open Capacity',
  CAPACITY_ALERT_ADD_FOR_ME: 'Capacity Alert Add for Me',
  CAPACITY_ALERT_X: 'Capacity Alert X',
  CALENDAR_MANAGEMENT_ALERT_DELETE_ALL: 'Calendar Management Alert Delete All',
  BULK_UNASSIGN_EDIT_MODE: 'Bulk Unassign Edit Mode',
  CONFIRM_BULK_UNASSIGN: 'Confirm Bulk Unassign',
  OPEN_DOCUMENTS: 'Open Documents',
  OPEN_CLIENT_DOCUMENTS_TAB: 'Open Client Documents Tab',
  OPEN_CLIENT_EVALUATION_TAB: 'Open Client Evaluation Tab',
  CREATE_NP_TEST_PLAN: 'Create NP Test Plan',
  COMPLETE_NP_INTAKE_NOTE: 'Complete NP Intake Note',
  UPLOAD_DOCUMENT: 'Upload Document',
  UPLOAD_DOCUMENT_FROM_COMPUTER: 'Upload Document From Computer',
  UPLOAD_DOCUMENT_FROM_LIBRARY: 'Upload Document From Library',
  CONFIRM_UPLOAD_DOCUMENT_FROM_LIBRARY: 'Confirm Upload Document From Library',
  OPEN_ITEMS_TAB_SELECT: 'Open Items Tab Select',
  OPEN_ITEMS_ROW_PRESS: 'Open Items Row Press',
  OPEN_ITEMS_HOVER_ACTION: 'Open Items Hover Action',
  OPEN_ITEMS_RISK_ALERT_MARK_ADDRESSED: 'Open Items Risk Alert Mark Addressed',
  OPEN_ITEMS_ADD_TASK: 'Open Items Add Task',
  AGENDA_DATE_SELECT: 'Agenda Date Select',
  AGENDA_ROW_PRESS: 'Agenda Row Press',
  DASHBOARD_SHARED_HOVER_ACTION: 'Dashboard Shared Hover Action',
  VIDEO_SESSION_PREFERENCE_EDIT: 'Video Session Preference Edit',
  VIDEO_SESSION_PREFERENCE_CANCEL: 'Video Session Preference Cancel',
  VIDEO_SESSION_PREFERENCE_CONTINUE: 'Video Session Preference Continue',
  VIDEO_SESSION_PREFERENCE_APPLY_TO_UPCOMING_SESSIONS_CANCEL:
    'Video Session Preference Apply to Upcoming Sessions Cancel',
  VIDEO_SESSION_PREFERENCE_APPLY_TO_UPCOMING_SESSIONS_KEEP_SELECTED:
    'Video Session Preference Apply to Upcoming Sessions Keep Selected',
  VIDEO_SESSION_PREFERENCE_APPLY_TO_UPCOMING_SESSIONS_UPDATE_SELECTED:
    'Video Session Preference Apply to Upcoming Sessions Update Selected',
  VIDEO_SESSION_PREFERENCE_APPLY_TO_UPCOMING_SESSIONS_SELECT_ALL:
    'Video Session Preference Apply to Upcoming Sessions Select All',
  VIDEO_SESSION_PREFERENCE_APPLY_TO_UPCOMING_SESSIONS_UPDATE:
    'Video Session Preference Apply to Upcoming Sessions Update',
  VIDEO_SESSION_PREFERENCE_APPLY_TO_UPCOMING_SESSIONS_UPDATE_AVAILABILITIES_ONLY:
    'Video Session Preference Apply to Upcoming Sessions Update Availabilities Only',
  VIDEO_SESSION_PREFERENCE_APPLY_TO_UPCOMING_AVAILABILITIES_UPDATE:
    'Video Session Preference Apply to Upcoming Availabilities Update',
  VIDEO_SESSION_PREFERENCE_APPLY_TO_UPCOMING_AVAILABILITIES_CANCEL:
    'Video Session Preference Apply to Upcoming Availabilities Cancel',
  CALENDAR_APPOINTMENT_MODALITY_CHANGED: 'Calendar Appointment Modality Changed',
  CALENDAR_AVAILABILITY_MODALITY_CHANGED: 'Calendar Availability Modality Changed',
  CALENDAR_APPOINTMENT_BOOKING_NON_DEFAULT_MODALITY_SELECTED:
    'Calendar Appointment Booking Non Default Modality Selected',
}

export const trackElementsMap = {
  OutcomesConsent: [
    { target: '#learn-more', action: actions.OUTCOMES_CONSENT_LEARN_MORE },
    { target: '#outcomes-not-now', action: actions.OUTCOMES_CONSENT_NOT_NOW },
  ],
  ClientDetails: [
    { target: '#outcomes-learn-more', action: actions.OUTCOMES_LEARN_MORE },
    { target: '#select-outcome-dropdown a', action: actions.OUTCOMES_CHANGE_DATE },
  ],
}

export const sessionNoteTypes = {
  session: 'FOLLOW UP',
  general: 'GENERAL',
  initial: 'INTAKE',
  referral: 'CARE REFERRAL',
  discharge: 'DISCHARGE',
}
